<template>
  <div class="EmptyCollection">
    <h3 class="h3">
      {{ terms.empty }}
    </h3>
    <button role="button" @click="handleClear">
      {{ terms.filters.clear }}
    </button>
  </div>
</template>

<script setup>
import { pubSub } from '@utils/PubSub';

defineProps({
  terms: {
    type: Object,
    default: () => ({}),
  },
});

const handleClear = () => pubSub.publish('plp:clear-filters');
</script>
